import React from "react";

const SearchFilter = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    <input
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className=" w-64 p-2 border  border-admin_black rounded-sm"
    />
  );
};

export default SearchFilter;
